// extracted by mini-css-extract-plugin
module.exports = {"actions":"TableCellActions_actions__20d0P"};